<template>
<BaseModal :id="'mail-inspection-modal'" :title="`Send Completed Inspection`" :message="message" @close="close($event)">
    <template v-slot:breadcrumb>
        <Breadcrumb :breadcrumb="breadcrumb" />
    </template>
    <template v-slot:content>
        <form @submit.prevent="sendInspection()">
            <FormDynamic :form_format="form_format" :form_data="form_data" :array_options="array_options" :for_update="false"/>
            <CentralLiteButtons :save_text="'Send'" :cancel_text="'Go back'" />
        </form>
    </template>
</BaseModal>
</template>
    
<script>
import Breadcrumb from "@/components/BreadcrumbComponent/Breadcrumb";
import CentralLiteButtons from '@/components/CentralLiteButtons'
import FormDynamic from '@/components/FormDynamic'
import BaseModal from "@/components/BaseModal";
import FormResource from "./form_resources";

export default {
    name: "MailInspectionModal",

    props: [
        "breadcrumb",
        "rest_api",
        "param_id"
    ],

    components: {
        BaseModal,
        Breadcrumb,
        CentralLiteButtons,
        FormDynamic
    },

    data() {
        return {
            message: `Since this inspection has been completed, and one or more associates have contributed, please select the associate you want to send the inspection results to. Each associate will only be able to view the inspection items they worked on.`,
            form_format: FormResource.form_format_for_mail_inspection,
            form_data: FormResource.form_data_for_mail_inspection,
            array_options: {
                associate_id: []
            }
        };
    },
    methods: {
        close(event) {
            this.$emit("close", event);
        },
        async sendInspection() {

            let json_request = {
                associate_id: this.form_data.associate_id,
                inspection_id: this.param_id,
            }

            const response = await this.postingByPost(`${this.rest_api}/post/send_copy_inspections_individually`, json_request, 'mail-inspection-modal', false)

            if (response.status) 
            {
                this.form_data.associate_id = []
                this.notyfMesg('Success')
            }
            else
            {
                this.error_handling(response)
            }
        },
        setAssociates(associates)
        {
            this.array_options = {...this.array_options, associate_id: associates}
        }


    },

    computed: {},

    mounted() {},
};
</script>
